import React from 'react';
import Lottie from 'react-lottie';
import * as animationData from '../../assets/animation/global_loader.json';

export default class LoginLoader extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isStopped: false, isPaused: false };
  }

  render() {
    const defaultOptions = {
      loop: true,
      autoplay: true,
      animationData: animationData,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice',
      },
    };

    return (
      <Lottie
        options={defaultOptions}
        height={this.props.height ?? 100}
        width={this.props.width ?? 200}
        isStopped={this.state.isStopped}
        isPaused={this.state.isPaused}
        style={{
          cursor: 'inherit',
        }}
      />
    );
  }
}
